<template>
</template>

<script>
import envConst from '@/env-const.js'
export default {
  data(){
    return {
      ApproveTaskDate: {
        addApproveTaskDate: {
            nextUserId: '',
            processDefinitionId: '',
            outgoingId: '',
            currnetUserId: '',
            approveOpinion: '',
            currentTaskId: '',
            processInstanceId: '',
            nextGroup:'',
            taskDefinitionKey:'',
            formData: {}
        },
        customFieldDate:[],
        taskState:'',
        transmitUserId:'',
        mtId:''
      },
      currentTaskId: ''
    }
  },
  created(){
    
  },
  methods: {
    //获取当前任务节点信息
    getCurrentTask(params,cb){
      //获取节点信息
      this.$http.post(`${envConst.API_BASE_URL}/scmd/flow/getCurTaskInfo/` + params.flow_instance_id).then(response => {
        if (response.data.returnCode == "0") {
          this.currentTaskId = response.data.bean.taskId == undefined ? "" : response.data.bean.taskId;
          if (this.currentTaskId == "") {
            this.$Message.warning("获取任务节点失败");
            return;
          }
          cb&&cb
        } else {
          this.$Message.error(response.data.returnMessage);
        }
      }).catch(error => {
        console.error("获取当前节点信息异常", error)
      })
    },
    endFlow(params){
      // this.getCurrentTask(params,()=>{
      //   this.ApproveTaskDate.addApproveTaskDate.processDefinitionId = params.flow_model_id;
      //   this.ApproveTaskDate.modelId = params.flow_model_id;
      //   this.ApproveTaskDate.addApproveTaskDate.processInstanceId = params.flow_instance_id;
      //   this.ApproveTaskDate.addApproveTaskDate.currentTaskId = this.currentTaskId;
      //   this.ApproveTaskDate.taskId = this.currentTaskId;
      //   this.ApproveTaskDate.addApproveTaskDate.nextGroup = '';//不指定人 提交不需要该参数
      //   this.ApproveTaskDate.mtId = params.mtId;
      //   this.ApproveTaskDate.taskState = params.flowState;
      //   this.ApproveTaskDate.handleType = 'EndProcess';
      //   this.approveTask();
      // })
      this.approveTask(params);
    },
    approveTask(params) {
      let _this = this;
      _this.$http.post(`${envConst.API_BASE_URL}/scmd/flow/endProcessByInstanceId`, {
          instanceId: params.flow_instance_id,
          mtId: params.mtId,
          objectName: params.objectName
        },
      ).then(function (data) {
        if (data.data.returnCode == 0) {
          // 获取需要渲染到页面中的数据
          if(data.data.bean.resFlag == 'success'){
            _this.$Message.success(data.data.bean.rtnMsg);
          }else{
            _this.$Message.warning(data.data.bean.rtnMsg);
          }
          
        } else {
          _this.$Message.error(data.data.returnMessage);
        }
      })
    },
  }
}
</script>

<style>

</style>